import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton, SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import isEqual from 'lodash.isequal';
import omit from 'lodash.omit';
import { useTranslation } from 'react-i18next';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
const StaffCostsTableData = _ref => {
  let {
    isSaved,
    setIsSaved,
    notSavedStyle,
    body,
    setBody,
    saveData,
    rowData,
    deleteData,
    data,
    removeEmptyRow,
    emptyRowId
  } = _ref;
  const {
    t
  } = useTranslation();
  const changeBody = e => {
    const key = e.target.name;
    const value = e.target.value;
    if (key === 'year' && !!rowData.id) {
      saveData({
        ...body,
        [key]: value
      });
    }
    setBody({
      ...body,
      [key]: value
    });
  };
  const saveOnBlur = () => {
    saveData(body);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    style: isSaved ? {} : notSavedStyle
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: body.employee_name_number,
    onBlur: saveOnBlur,
    name: "employee_name_number",
    onChange: changeBody,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
    style: {
      width: '150px'
    },
    as: "select",
    name: "year",
    onChange: changeBody,
    onBlur: saveOnBlur,
    size: "md",
    value: body.year
  }, /*#__PURE__*/React.createElement("option", {
    key: 'year_after_staff',
    value: 'after_30_06_2020'
  }, t('after_30_06_2020')), /*#__PURE__*/React.createElement("option", {
    key: 'year_before_staff',
    value: 'before_01_07_2020'
  }, t('before_01_07_2020')))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "sum_working_hr_rd",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 2,
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "rel_agreed_annual_working_hrs",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: body.fulltime
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    decimalScale: 1,
    onChange: changeBody,
    object: rowData.calculations,
    name: "share_of_working_time",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true,
    suffix: '%'
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "a1_exec_special_payment",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: body,
    onBlur: saveOnBlur,
    name: "a2_sum_special_payments",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: rowData.calculations,
    name: "sum_of_a1_a2",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    onBlur: saveOnBlur,
    object: body,
    name: "employers_social_security",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: rowData.calculations,
    name: "gross_wage",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: changeBody,
    object: rowData.calculations,
    name: "b_excluding_special_payments",
    type: "text",
    size: "sm",
    onlyPositiveNumbers: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      marginRight: '8px'
    },
    onClick: () => emptyRowId !== null ? removeEmptyRow(emptyRowId) : deleteData(body),
    "data-testid": "delete_button"
  }))));
};
export default StaffCostsTableData;